module.exports = __webpack_public_path__ + "static/img/payment_eq_zfb.681b222.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/payment_eq_zfb.png
// module id = +j2F
// module chunks = 0